module.exports = __webpack_public_path__ + "static/img/1.d13767a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/1.png
// module id = uBvV
// module chunks = 0